export const CodesDropDown = (data) => {
    return {
      type: 'CodesDropDown',
      payload: data
    }
}
